"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imThemeContext = void 0;
var _react = require("react");
var imThemeContext = exports.imThemeContext = /*#__PURE__*/(0, _react.createContext)(undefined);